import React from "react";

import "./shadow-table.scss";

const ShadowTable = () => {
    return <div className="shadow-table"></div>;
};

export default ShadowTable;
